import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';
import { getVoidTypeMessageDescriptor, getVoidTypeKeyFromFilterValue } from '../../../void-type/void-type-mappings';
import { VOID_TYPE } from '../../../../filters/constants';

import { messages } from './messages';

const getDisplayName = (appliedFilters = []) => {
  const voidTypeFilters = appliedFilters?.filter((currentFilter) => currentFilter.filterById === VOID_TYPE);

  if (voidTypeFilters?.length === 0) {
    return <FormattedMessage {...messages.defaultVoidTypeFilterText} />;
  }

  if (voidTypeFilters.length === 1) {
    const filter = voidTypeFilters[0];
    // Use the reverse mapping to get the void type key for display
    const voidTypeKey = getVoidTypeKeyFromFilterValue(filter?.criterionArgumentValue, filter?.criterionOperatorValue);

    if (voidTypeKey) {
      const messageDescriptor = getVoidTypeMessageDescriptor(voidTypeKey);
      if (messageDescriptor) {
        return <FormattedMessage {...messageDescriptor} />;
      }
    }

    return String(filter?.criterionArgumentValue);
  }

  return <FormattedMessage {...messages.multipleVoidTypes} />;
};

const mapStateToProps = (state, ownProps) => {
  const appliedFilters = Global.selectShipmentsFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });

  return {
    isSelected: !!appliedFilters.length,
    displayContent: getDisplayName(appliedFilters),
  };
};

export const VoidType = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
